import React from "react";

const GoogleSvg = () => {
    return (
        <svg style={{marginRight: "6px"}} width="25px" height="25px" viewBox="-0.5 0 48 48" version="1.1" fill="#000000" >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
            <g id="SVGRepo_iconCarrier">
                <title>Google-color</title>
                <desc>Created with Sketch.</desc>
                <defs/>
                <g
                    id="Icons"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <g
                        id="Color-"
                        transform="translate(-401.000000, -860.000000)"
                    >
                        <g
                            id="Google"
                            transform="translate(401.000000, 860.000000)"
                        >
                            <path
                                d="M9.82727273,24 C9.82727273,22.4757333 10.0804318,21.0144 10.5322727,19.6437333 L2.62345455,13.6042667 C1.08206818,16.7338667 0.213636364,20.2602667 0.213636364,24 C0.213636364,27.7365333 1.081,31.2608 2.62025,34.3882667 L10.5247955,28.3370667 C10.0772273,26.9728 9.82727273,25.5168 9.82727273,24"
                                id="Fill-1"
                                fill="#FBBC05"
                            />
                            <path
                                d="M23.7136364,10.1333333 C27.025,10.1333333 30.0159091,11.3066667 32.3659091,13.2266667 L39.2022727,6.4 C35.0363636,2.77333333 29.6954545,0.533333333 23.7136364,0.533333333 C14.4268636,0.533333333 6.44540909,5.84426667 2.62345455,13.6042667 L10.5322727,19.6437333 C12.3545909,14.112 17.5491591,10.1333333 23.7136364,10.1333333"
                                id="Fill-2"
                                fill="#EB4335"
                            />
                            <path
                                d="M23.7136364,37.8666667 C17.5491591,37.8666667 12.3545909,33.888 10.5322727,28.3562667 L2.62345455,34.3946667 C6.44540909,42.1557333 14.4268636,47.4666667 23.7136364,47.4666667 C29.4455,47.4666667 34.9177955,45.4314667 39.0249545,41.6181333 L31.5177727,35.8144 C29.3995682,37.1488 26.7323182,37.8666667 23.7136364,37.8666667"
                                id="Fill-3"
                                fill="#34A853"
                            />
                            <path
                                d="M46.1454545,24 C46.1454545,22.6133333 45.9318182,21.12 45.6113636,19.7333333 L23.7136364,19.7333333 L23.7136364,28.8 L36.3181818,28.8 C35.6879545,31.8912 33.9724545,34.2677333 31.5177727,35.8144 L39.0249545,41.6181333 C43.3393409,37.6138667 46.1454545,31.6490667 46.1454545,24"
                                id="Fill-4"
                                fill="#4285F4"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

const PasswordLockSvg = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6 8V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6ZM19 10H5V20H19V10ZM11 15.7324C10.4022 15.3866 10 14.7403 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 14.7403 13.5978 15.3866 13 15.7324V18H11V15.7324ZM8 8H16V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8Z"
                fill="#1C1C1C"
            />
        </svg>
    )
}

const PasswordHideIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.84998 2.15C2.75568 2.05892 2.62938 2.00852 2.49828 2.00966C2.36718 2.0108 2.24178 2.06339 2.14907 2.15609C2.05637 2.24879 2.00378 2.3742 2.00264 2.5053C2.0015 2.6364 2.0519 2.7627 2.14298 2.857L13.143 13.857C13.2373 13.9481 13.3636 13.9985 13.4947 13.9973C13.6258 13.9962 13.7512 13.9436 13.8439 13.8509C13.9366 13.7582 13.9892 13.6328 13.9903 13.5017C13.9915 13.3706 13.9411 13.2443 13.85 13.15L2.84998 2.15ZM15 8.88C14.566 9.474 14.115 10 13.65 10.47L12.943 9.763C13.3723 9.33367 13.789 8.84367 14.193 8.293C14.2463 8.22002 14.2788 8.13397 14.287 8.04399C14.2953 7.95401 14.279 7.86347 14.24 7.782L14.195 7.707C12.445 5.307 10.475 4.087 8.26498 4.007L8.00898 4.002C7.74588 4.00073 7.48298 4.01676 7.22198 4.05L6.35998 3.188C6.90108 3.06311 7.45466 3.00037 8.00998 3.001C10.67 3.001 13.01 4.391 15 7.121C15.1877 7.37789 15.2889 7.68783 15.2889 8.006C15.2889 8.32417 15.1877 8.6341 15 8.891V8.88Z"
                fill="black"/>
            <path
                d="M11 7.83C10.9578 7.0932 10.6461 6.39766 10.1242 5.8758C9.60236 5.35395 8.90682 5.04223 8.17001 5L11 7.83ZM1.22001 6.83C1.58735 6.35 1.96735 5.91667 2.36001 5.53L3.06701 6.237C2.63768 6.66633 2.22101 7.15633 1.81701 7.707L1.77001 7.786C1.73772 7.85343 1.72095 7.92724 1.72095 8.002C1.72095 8.07676 1.73772 8.15057 1.77001 8.218L1.81401 8.292C3.56401 10.692 5.53401 11.912 7.74401 11.992L8.00001 11.997C8.26601 11.997 8.52835 11.981 8.78701 11.949L9.64801 12.809C9.10695 12.9342 8.55337 12.9973 7.99801 12.997C5.33801 12.997 2.99801 11.607 1.00801 8.877L0.926013 8.752C0.777719 8.4997 0.706468 8.20953 0.721038 7.91724C0.735608 7.62495 0.835363 7.3433 1.00801 7.107L1.22301 6.82L1.22001 6.83Z"
                fill="black"/>
            <path
                d="M7.83 11C7.0932 10.9578 6.39766 10.6461 5.8758 10.1242C5.35395 9.60236 5.04223 8.90682 5 8.17001L7.83 11Z"
                fill="black"/>
        </svg>
    )
}

const PasswordShowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/>
            <circle cx="12" cy="12" r="3"/>
        </svg>
    )
}

const EmailIconSvg = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4ZM4 6V6.01L12 12L20 6.01V6H4ZM20 8.51L12.5534 13.8944C12.221 14.1374 11.779 14.1374 11.4466 13.8944L4 8.51V18H20V8.51Z"
                fill="#1C1C1C"
            />
        </svg>
    )
}

const ProfileIconSvg  = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20 22H18V20C18 18.3431 16.6569 17 15 17H9C7.34315 17 6 18.3431 6 20V22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13ZM12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                fill="#1C1C1C"
            />
        </svg>
    )
}

export {GoogleSvg,PasswordLockSvg,PasswordHideIcon, PasswordShowIcon,EmailIconSvg,ProfileIconSvg}
